import Vue from "vue";
import App from "./App.vue";
import LangRouter from "vue-lang-router";
import { i18n } from "vue-lang-router";
import BootstrapVue from "bootstrap-vue";
import WOW from "wow.js/dist/wow.js";
import VueMeta from "vue-meta";

import GTag from "./plugins/gtag.js";
import translations from "./translations/index.js";

Vue.use(LangRouter, {
	defaultLanguage: "en",
	translations: translations,
});
Vue.use(BootstrapVue);
Vue.use(VueMeta, {
	refreshOnceOnNavigation: true,
});

import "bootstrap/dist/css/bootstrap.css";
import "../src/assets/css/fontawesome-all.min.css";
import "animate.css/animate.min.css";
import "../src/assets/scss/style.scss";

Vue.config.productionTip = false;
Vue.config.productionSourceMap = false;

import { routes } from "./router/index";

const router = new LangRouter({
	routes,
	mode: "history",
});

Vue.use(GTag, {
	id: "AW-950463112",
});

new Vue({
	router,
	i18n,
	render: h => h(App),
	mounted() {
		new WOW().init();
	},
}).$mount("#app");
